import { Injectable } from '@angular/core';
import type { ChecklistTypeFindInterface } from '@zaoblako/shared/modules/project/dto/checklist-type/checklist-type-find.dto';
import type { ChecklistFinishInterface } from '@zaoblako/shared/modules/project/dto/checklist/checklist-finish.dto';
import type { ChecklistQueryInterface } from '@zaoblako/shared/modules/project/dto/checklist/checklist-query.dto';
import type { ChecklistRescheduleInterface } from '@zaoblako/shared/modules/project/dto/checklist/checklist-reschedule.dto';
import type { ChecklistFindInterface } from '@zaoblako/shared/modules/project/dto/checklist/checklist-find.dto';
import type { ChecklistReopenInterface } from '@zaoblako/shared/modules/project/dto/checklist/checklist-reopen.dto';
import { BaseService } from '@zaoblako/web/core/services/base.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ProjectChecklistService extends BaseService {
  protected baseUrl = '/project-checklist';

  public getChecklistTypes(): Observable<ChecklistTypeFindInterface[]> {
    return this.http.get<ChecklistTypeFindInterface[]>(`${this.baseUrl}/types`);
  }

  public finish(checklistId: number, body: ChecklistFinishInterface): Observable<ChecklistFindInterface> {
    return this.http.put<ChecklistFindInterface>(`${this.baseUrl}/${checklistId}/finish`, body);
  }

  public reopen(checklistId: number, body: ChecklistReopenInterface): Observable<ChecklistFindInterface> {
    return this.http.put<ChecklistFindInterface>(`${this.baseUrl}/${checklistId}/reopen`, body);
  }

  public getChecklistsByProjectId(
    projectId: number,
    queryParams?: ChecklistQueryInterface
  ): Observable<ChecklistFindInterface[]> {
    return this.http.get<ChecklistFindInterface[]>(`/project/${projectId}/checklist`, {
      params: queryParams ? this.objectToHttpParams(queryParams) : {}
    });
  }

  public reschedule(checklistId: number, body: ChecklistRescheduleInterface): Observable<null> {
    return this.http.put<null>(`${this.baseUrl}/${checklistId}/reschedule`, body);
  }
}
